<template>

<div class="footer">
    <div class="footer-pack">
        <div class="footer-about">
            <img src="@/assets/logo-header.png" alt="">
            <p>{{ t('home.glance.text') }}</p>
        </div>

        <nav class="footer-menu">
            <ul>
                <li><a target="_blank" href="http://www.imam-khomeini.ir/">{{ t('footer.links.imam') }}</a></li>
                <li><a target="_blank" href="https://www.leader.ir/fa">{{ t('footer.links.leader') }}</a></li>
                <li><a target="_blank" href="https://ismc.ir/">{{ t('footer.links.ismc') }}</a></li>
                <li><a target="_blank" href="https://whc.ir/">{{ t('footer.links.whc') }}</a></li>
                <li><a target="_blank" href="https://www.hawzahnews.com/">{{ t('footer.links.hNews') }}</a></li>
                <li><a target="_blank" href="https://csis.ir/">{{ t('footer.links.csis') }}</a></li>
                <li><a target="_blank" href="https://miu.ac.ir/">{{ t('footer.links.miu') }}</a></li>
            </ul>
        </nav>

        <div class="footer-address">
            <h3>{{ t('footer.addresses.title') }}</h3>
            <h4>{{ t('footer.addresses.address.title') }}</h4>
            <p><a href="https://balad.ir/p/Pc1ysTvgdMNAxu" target="_blank">{{ t('footer.addresses.address.address') }}</a></p>
            <h4>{{ t('footer.addresses.telephone.title') }}</h4>
            <p><a href="tel:+982532400204">{{ t('footer.addresses.telephone.number.first') }}</a> | <a href="tel:+982532400205">{{ t('footer.addresses.telephone.number.second') }}</a> | <a href="tel:+982532400206">{{ t('footer.addresses.telephone.number.third') }}</a></p>
            <h4>{{ t('footer.addresses.postalCode.title') }}</h4>
            <p>{{ t('footer.addresses.postalCode.code') }}</p>
            <h4>{{ t('footer.addresses.eMail.title') }}</h4>
            <p><a href="mailto:info@howzehmeshkat.ir" target="_blank">{{ t('footer.addresses.eMail.address') }}</a></p>

            <div class="social">
                <div class="social">
                    <h3>{{ t('footer.socials') }}</h3>
                    <div class="social-icons">
                        <img style="cursor: pointer" src="@/assets/eitaa.png" onclick="location.href = `https://eitaa.com/`">
                        <img style="cursor: pointer" src="@/assets/bale.png" onclick="location.href = `https://ble.ir/howzehmeshkat`">
                        <img style="cursor: pointer" src="@/assets/aparat.png" onclick="location.href = `https://www.aparat.com/howzehmeshkat`">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom">
        {{ t('footer.copyright', { year: (new Date()).toLocaleDateString(t('timeLocale')).match(/[^/ ]{4}/g)[0] }) }}
    </div>
</div>

</template>

<script setup>

import { useI18n } from 'vue-i18n'

const { locale, t } = useI18n()

</script>

<style lang="less">

.footer {
    width: 100%;
    margin: 0 auto;
    background: #4c4c4c;
}
.footer-pack {
    display: flex;
    width: 70%;
    margin: 0 auto;
    padding: 80px 0;
    justify-content: space-between;
}
.footer-about {
    width: 25%;
}
.footer-about img {
    text-align: center;
    margin: 0 auto;
    border-bottom: 1px solid #8a5f2e;
    padding-bottom: 10px;
    margin-bottom: 10px;
}
.footer-about p {
    font-size: 100%;
    color: #eaeaea;
    text-align: justify;
    line-height: normal;
    margin: 0;
}
.footer-menu {
    width: 25%;
    margin: 0;
    border-right: 1px solid #8a5f2e;
    padding-right: 30px;
}
.footer-menu ul {
    list-style: none;
    padding: 0;
}
.footer-menu a{
color: #efefef;
    text-decoration: none;
    line-height: 35px;
}
.footer-address {
    width: 30%;
}
.footer-address h3 {
    color: #209f89;
    font-size: 25px;
    border-right: 20px solid #8a5f2e;
    padding-right: 20px;
    font-weight: bold;
    text-align: center;
    margin: 0px auto 20px;
    display: inline-block;
}
.footer-address h4 {
    color: #eaeaea;
    font-size: 20px;
}
.footer-address p {
    color: #efefef;
    margin: 0 0 40px;
}
.footer-address span {
    color: #efefef;
    letter-spacing: 5px;
}
.social-icons {
    display: flex;
    justify-content: space-between;
    width: 180px;
}
.footer-bottom {
    width: 100%;
    background: #646464;
    border-top: 1px solid #838383;
    color: #d1d1d1;
    text-align: center;
    padding: 20px 0;
}

</style>